import { takeLatest, put } from "redux-saga/effects";

import { canvasPathActions } from "actions/canvasPathActions.js";

import { GET_DATA } from "actions/apiOperations.js";

export const requestCanvasPath = function* (action) {
  const { buyplanId, filename } = action.payload;

  yield put({
    type: GET_DATA,
    path: `/api/buyplans/${buyplanId}/canvas/path`,
    actions: canvasPathActions,
    params: { visual_planner_name: filename }
  });
};

export const watchCanvasPath = function* () {
  yield takeLatest(
    canvasPathActions.request,
    requestCanvasPath
  );
};
